<template>
  <div class="subscription">
    <SettingsBlock title="Your plan">
      <div
        v-if="this.$store.getters['user/currentUserSubscriptionActive']()"
        class="content"
      >
        <div class="subscription-block-plan-label">
          {{ userPlanLabel }}
        </div>
        <div class="subscription-block-plan-sublabel">
          {{ userPlanSubLabel }}
        </div>
        <p
          v-if="
            this.$store.getters['user/isCurrentUserSubscriptionCancellling']()
          "
          class="subscription-cancelling"
        >
          Your subscription is set to cancel at the end of the billing period.
        </p>
        <div
          v-if="
            this.$store.getters['user/isCurrentUserSubscriptionStripe']() ||
            this.$store.getters['user/isCurrentUserSubscriptionAppStore']()
          "
        >
          <RoundedButton
            text="Modify Subscription"
            mediumwide
            lessRound
            bold
            accent
            @click="modifySubscription"
            @keydown="
              ($event) => {
                if ($event.key === 'Enter') {
                  $event.preventDefault();
                  modifySubscription();
                }
              }
            "
            :aria-label="'Modify Subscription'"
            :loading="modifySubscriptionLoading"
            class="modify-subscription-button"
          />
          <p class="relog-message">
            Note: changes to your subscription will appear here after relogging.
          </p>
          <div
            v-if="modifySubscriptionError"
            class="modify-subscription-error error"
          >
            There was an error opening the Stripe Customer Portal.
          </div>
        </div>
      </div>
      <div v-else class="content">
        <p>You are not currently on any subscription.</p>
        <div v-if="this.$store.state.user.currentUser.type !== 'Org User'">
          <RoundedButton
            text="See subscription plans"
            mediumwide
            lessRound
            bold
            accent
            @click="
              () => {
                this.showSubscriptionSignupDialog = true;
              }
            "
            @keydown="
              ($event) => {
                if ($event.key === 'Enter') {
                  $event.preventDefault();
                  this.showSubscriptionSignupDialog = true;
                }
              }
            "
            :aria-label="'See subscription plans'"
            class="see-subscription-plans-button"
          />
        </div>
      </div>
      <SubscriptionSignup
        :visible="showSubscriptionSignupDialog"
        :setVisible="setShowSubscriptionSignupDialog"
      />
    </SettingsBlock>
  </div>
</template>

<script>
import SubscriptionSignup from "../Onboarding/SubscriptionSignup.vue";
import RoundedButton from "../RoundedButton";
import SettingsBlock from "./SettingsBlock.vue";
import { APP_STORE_URL } from "../../assets/constants";

export default {
  components: {
    SubscriptionSignup,
    SettingsBlock,
    RoundedButton,
  },

  data() {
    return {
      showSubscriptionSignupDialog: false,
      modifySubscriptionLoading: false,
      modifySubscriptionError: false,
    };
  },

  computed: {
    userPlanLabel() {
      const subscriptionType =
        this.$store.state.user.currentUser.self.subscription.type.toUpperCase() ||
        "Free";
      if (this.$store.state.user.currentUser.type === "Org User") {
        return `${subscriptionType} plan`;
      } else {
        return this.$store.getters["user/isCurrentUserSubscriptionTrial"]()
          ? "Free plan"
          : `Monthly ${subscriptionType} plan`;
      }
    },

    // TODO: align with the new subscription setting block design
    userPlanSubLabel() {
      return this.$store.state.user.currentUser.type === "Org User"
        ? "*Your subscription is managed by your organization."
        : "";
    },
  },

  methods: {
    modifySubscription() {
      if (this.$store.getters["user/isCurrentUserSubscriptionStripe"]) {
        this.modifySubscriptionError = false;
        this.modifySubscriptionLoading = true;

        var sessionsHeaders = new Headers();
        sessionsHeaders.append("content-type", "application/json");
        sessionsHeaders.append(
          "Authorization",
          `Bearer ${JSON.parse(localStorage.getItem("tokenMP")).accessToken}`
        );
        var sessionRequestOptions = {
          method: "post",
          headers: sessionsHeaders,
          redirect: "follow",
        };
        fetch(
          process.env.VUE_APP_MP_SERVER_API_URL +
            "self/create-customer-portal-session",
          sessionRequestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            let data = JSON.parse(result);
            this.modifySubscriptionLoading = false;

            if (data.status === "error") {
              this.modifySubscriptionError = true;
            } else {
              window.open(data.data.url, "_blank");
            }
          })
          .catch((e) => {
            console.log("Error modifying subscription: ", e);
            this.modifySubscriptionError = true;
            this.modifySubscriptionLoading = false;
          });
      } else {
        // App Store subscription
        window.open(APP_STORE_URL, "_blank");
      }
    },

    setShowSubscriptionSignupDialog(bool) {
      this.showSubscriptionSignupDialog = bool;
    },
  },
};
</script>

<style lang="scss" scoped>
.subscription-block-plan-label {
  color: map-get($colours, lilac);
  margin-top: 1.6rem;
  margin-bottom: 0.4rem;
}

.subscription-block-plan-sublabel {
  color: map-get($colours, overlay-white);
  font-size: 1.2rem;
}
</style>